import { render, staticRenderFns } from "./CollectorOrderTable.vue?vue&type=template&id=6450ab29&scoped=true&"
import script from "./CollectorOrderTable.vue?vue&type=script&lang=js&"
export * from "./CollectorOrderTable.vue?vue&type=script&lang=js&"
import style0 from "./CollectorOrderTable.vue?vue&type=style&index=0&id=6450ab29&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6450ab29",
  null
  
)

export default component.exports